import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../config/supabase';

export const useAdminCheck = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (authLoading) {
        return;
      }

      if (!user) {
        navigate('/settings');
        return;
      }

      try {
        const { data: profile, error } = await supabase
          .from('roles')
          .select('role')
          .eq('id', user.id)
          .single();

        if (error) {
          console.error('Erreur lors de la vérification du rôle:', error);
          navigate('/settings');
          return;
        }

        if (profile?.role !== 'admin') {
          navigate('/settings');
          return;
        }

        setIsAdmin(true);
      } catch (error) {
        console.error('Erreur lors de la vérification admin:', error);
        navigate('/settings');
      } finally {
        setLoading(false);
      }
    };

    checkAdmin();
  }, [user, authLoading, navigate]);

  return { isAdmin, loading: loading || authLoading };
};
